import { ForwardedRef, forwardRef, ReactNode } from 'react';
import classNames from 'classnames';

import styles from './submenu.module.css';

interface SubmenuProps {
  id?: string,
  open: boolean,
  children: ReactNode,
  width?: string,
  position?: string,
}

const Submenu = forwardRef(({ id, open, children, width, position }: SubmenuProps, ref: ForwardedRef<HTMLDivElement>) => {
  return (
    <div className={classNames(styles.root, open && styles.open, width === '100%' && styles.fullWidth)} style={{ width, left: position }}>
      <div id={id} className={styles.container} ref={ref}>
        <div className={styles.content}>
          {children}
        </div>
      </div>
    </div>
  );
});

Submenu.displayName = 'Submenu';

export default Submenu;
